import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-user-links-info-panel',
  templateUrl: './user-links-info-panel.component.html',
  styleUrls: ['./user-links-info-panel.component.scss']
})
export class UserLinksInfoPanelComponent implements OnInit {
  @Input() user: User;
  constructor() { }

  ngOnInit() {
  }

}
